import { IDetailsPayload, SidebarOpenMode } from '../detailsSidebar.interface';

export enum RouteActionVariant {
  NOOP,
  AddId,
  UpdateId,
  RemoveId,
}

const isSidebarMappedToPathParam = ({ id, mode }: IDetailsPayload) =>
  id !== undefined && (mode === SidebarOpenMode.View || mode === SidebarOpenMode.Edit);

const makeResponse = (action: RouteActionVariant, state?: IDetailsPayload) => {
  if (!state) {
    return { action };
  }

  const { id, mode, type } = state;
  return {
    action,
    locationState: { mode, type }, //Pass SidebarOpenMode and type to a new route inside the location state
    segment: id,
  };
};

export const defineRouteAction = ({ prevState, nextState }: { prevState: IDetailsPayload, nextState: IDetailsPayload }) => {
  if (prevState.id === nextState.id) {
    return makeResponse(RouteActionVariant.NOOP);
  }

  const isPreviousSidebarMappedToPathParam = isSidebarMappedToPathParam(prevState);
  const isNextSidebarMappedToPathParam = isSidebarMappedToPathParam(nextState);

  if (isNextSidebarMappedToPathParam && isPreviousSidebarMappedToPathParam) {
    return makeResponse(RouteActionVariant.UpdateId, nextState);
  }

  if (isNextSidebarMappedToPathParam && !isPreviousSidebarMappedToPathParam) {
    return makeResponse(RouteActionVariant.AddId, nextState);
  }

  if (!isNextSidebarMappedToPathParam && isPreviousSidebarMappedToPathParam) {
    return makeResponse(RouteActionVariant.RemoveId, nextState);
  }

  return makeResponse(RouteActionVariant.NOOP);
};
